module.exports = __webpack_public_path__ + "img/mission1.ba33351c.png";